"use client";
import styles from "./generator.module.scss";
import "react-range-slider-input/dist/style.css";
import { useSearchParams, usePathname, useRouter } from "next/navigation";
import PriceRange from "./PriceRange";
import { useEffect, useState } from "react";
import ProductList from "@/src/app/components/Generator/productlist";

export default function Generator({ categories }) {
  const searchParams = useSearchParams();
  const occasion = searchParams.get("occasion") || "";
  const ageMin = searchParams.get("ageMin") || "0";
  const ageMax = searchParams.get("ageMax") || "100";
  const priceMin = searchParams.get("priceMin") || "0";
  const priceMax = searchParams.get("priceMax") || "Infinity";
  const pathname = usePathname();
  const router = useRouter();
  const occasions = [
    { label: "Välj ett tillfälle...", value: "" },
    { label: "🎂 Födelsedag", value: "birthday" },
    { label: "💖 Alla hjärtans dag", value: "valentine" },
    { label: "🤱 Morsdag", value: "mothersday" },
    { label: "👨‍🍼 Farsdag", value: "fathersday" },
    { label: "🏡 Inflytt", value: "move" },
    { label: "💍 Giftemål", value: "marriage" },
    { label: "🥂 Smekmånad", value: "honeymoon" },
    { label: "🎄 Julafton", value: "christmas" },
    { label: "🥳 Fest", value: "party" },
    { label: "🇸🇪 Student", value: "student" },
    { label: "👵🏻👴🏻 Pension", value: "retirement" },
    { label: "🐱🐶 Husdjur", value: "pet" },
    { label: "🚲 Bud", value: "delivery" },
  ];

  const handleChange = (e) => {
    const newOccasion = e.target.value;
    const params = new URLSearchParams(searchParams);

    if (newOccasion) {
      params.set("occasion", newOccasion);
    } else {
      params.delete("occasion");
    }

    router.push(`${pathname}?${params.toString()}`, { scroll: false });
  };

  const clearFilters = () => {
    router.push("/", { scroll: false });
  };

  const [selectedCategory, setSelectedCategory] = useState("");
  const [shuffledProducts, setShuffledProducts] = useState([]);

  useEffect(() => {
    const allProducts = selectedCategory
      ? categories[selectedCategory] || []
      : Object.values(categories).flat();

    const shuffled = [...allProducts].sort(() => 0.5 - Math.random());
    setShuffledProducts(shuffled);
  }, [categories, selectedCategory]);

  const filteredProducts = shuffledProducts
    .filter((prod) => (occasion ? prod.occasion?.includes(occasion) : true))
    .filter((prod) => prod.price.min <= priceMax && prod.price.max >= priceMin)
    .filter((prod) => prod.age.min <= ageMax && prod.age.max >= ageMin);

  return (
    <>
      <div className={styles.filterWrapper}>
        <div className={styles.filter}>
          <div className={styles.selectWrapper}>
            <label htmlFor="occasion-select" className={styles.visuallyHidden}>
              Välj tillfälle
            </label>
            <select
              id="occasion-select"
              value={occasion}
              onChange={handleChange}
            >
              {occasions.map((occasion, i) => (
                <option value={occasion?.value} key={i}>
                  {occasion.label}
                </option>
              ))}
            </select>
          </div>
          <PriceRange />
          <div className={styles.selectWrapper}>
            <label htmlFor="category-select" className={styles.visuallyHidden}>
              Välj kategori
            </label>
            <select
              id="category-select"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="">Alla kategorier</option>
              {Object.keys(categories).map((cat, i) => {
                const prettyName = categories[cat]?.[0]?.category?.[0] || cat;
                return (
                  <option key={i} value={cat}>
                    {prettyName}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div
          className={
            priceMax !== "Infinity" || occasion !== ""
              ? `${styles.btnClearWrapper} ${styles.active}`
              : styles.btnClearWrapper
          }
        >
          <button
            type="button"
            className={styles.btnClear}
            onClick={clearFilters}
          ></button>
        </div>
      </div>

      <ProductList shuffledProducts={filteredProducts} />
    </>
  );
}
